export enum PalantirFilterInputType {
  /**
   * Componente customizado.
   * - **IMPORTANTE**: Esse tipo de filtro deve ser utilizado apenas em casos específicos, onde os tipos de filtro padrão não atendem as necessidades, caso haja a necessidade de criar um filtro customizado que seja reutilizável, deve-se criar um novo tipo de filtro no Palantir.
   */
  CUSTOM = 'CUSTOM',
  /**
   * Filtro de data
   */
  DATE = 'DATE',
  /**
   * Filtro de data com range, com data inicial e final. Esse filtro vai retornar um objeto com as duas datas.
   */
  DATE_RANGE = 'DATE_RANGE',
  /**
   * Filtro de busca múltipla
   */
  MULTI_SEARCH = 'MULTI_SEARCH',
  /**
   * Filtro de seleção múltipla
   */
  MULTI_SELECT = 'MULTI_SELECT',
  /**
   * Filtro de número
   */
  NUMBER = 'NUMBER',
  /**
   * Filtro de busca
   */
  SEARCH = 'SEARCH',
  /**
   * Filtro de seleção única
   */
  SELECT = 'SELECT',
  /**
   * Filtro de texto
   */
  TEXT = 'TEXT',
}

/**
 * Comportamento do serviço de filtro ao salvar os filtros
 */
export enum PalantirFilterSaveStrategy {
  /**
   * Salva o filtro no local storage
   */
  LOCAL_STORAGE = 'LOCAL_STORAGE',
  /**
   * Não salva os filtros
   */
  NONE = 'NONE',
  /**
   * Salva o filtro na query string
   */
  QUERY_STRING = 'QUERY_STRING',
}

/**
 * Comportamento do serviço de filtro ao encontrar um filtro inválido
 */
export enum PalantirFilterInvalidBehavior {
  /**
   * Caso a validação do filtro falhe, o filtro será ignorado e o valor do filtro será null.
   * - Esse comportamento também é considerado com filtros dependentes, ou seja, caso um filtro dependa de um filtro inválido, o seu valor será null.
   */
  IGNORE = 'IGNORE',
  /**
   * Caso a validação do filtro falhe, o valor do filtro será mantido
   * - Esse comportamento também é considerado com filtros dependentes, ou seja, caso um filtro dependa de um filtro inválido, o seu valor será mantido.
   */
  KEEP = 'KEEP',
}

export enum PalantirFilterClearFiltersOnDestroyBehavior {
  /**
   * Limpa os filtros ao destruir o modal de filtro
   * - Esse comportamento é útil para modais de filtro que não devem manter o estado dos filtros após serem fechados
   * - Esse é o comportamento padrão
   */
  CLEAR = 'CLEAR',
  /**
   * Não limpa os filtros ao destruir o modal de filtro
   * - Esse comportamento é útil para modais de filtro que devem manter o estado dos filtros após serem fechados
   */
  KEEP = 'KEEP',
}

/**
 * Configurações do input de busca quando dependente de um filtro
 */
export enum PalantirFilterSearchInputDependsOnBehavior {
  /**
   * Não faz nada
   */
  IGNORE = 'IGNORE',
  /**
   * Recarrega o filtro de busca sempre que o filtro dependente for alterado
   */
  RELOAD_IF_CHANGED = 'RELOAD_IF_CHANGED',
  /**
   * Completamente reseta o filtro de busca sempre que o filtro dependente for alterado
   */
  RESET_IF_CHANGED = 'RESET_IF_CHANGED',
}

/**
 * Configurações do input de busca quando o preloader falha ou não retorna todos os valores
 */
export enum PalantirFilterSearchInputOptionLoaderFailedBehavior {
  /**
   * Esse comportamento é dependente do tipo de filtro:
   * - `SEARCH`: Mantém o valor selecionado, define o layout padrão para o básico
   * - `MULTI_SEARCH`: Mantém os valores selecionados, define o layout padrão para os não encontrados e adiciona os novos valores
   */
  KEEP = 'KEEP',
  /**
   * Substitui os valores já carregados pelos novos valores
   */
  REPLACE = 'REPLACE',
  /**
   * Completamente reseta o filtro de busca
   */
  RESET = 'RESET',
}

/**
 * Comportamento do filtro dependente em relação ao filtro pai quando um valor é selecionado
 */
export enum PalantirFilterDependsOnValueEvaluationBehavior {
  /**
   * O filtro dependente deve conter todos os valores do filtro
   * - Esse comportamento só é aplicado para filtros de seleção múltipla
   */
  ALL_CONTAINS = 'ALL_CONTAINS',
  /**
   * O filtro dependente nao deve conter nenhum dos valores do filtro
   */
  NONE_CONTAINS_OR_NOT_EQUAL = 'NONE_CONTAINS_OR_NOT_EQUAL',
  /**
   * O filtro dependente deve conter um dos valores do filtro
   */
  SOME_CONTAINS_OR_EQUAL = 'SOME_CONTAINS_OR_EQUAL',
}
